import {
  InfoModule,
  createInfoServices
} from "./chunk-RKFCU2KB.mjs";
import "./chunk-DHJNZKBA.mjs";
export {
  InfoModule,
  createInfoServices
};
